module.exports = __webpack_public_path__ + "images/icons_v2/get-started-outlined-c353a5d0.svg";